<template>
    <div class="faq">
        <SubHeader />
        <router-view />
    </div>
</template>

<script>
import faq from '../../assets/faq.json';
import SubHeader from './SubHeader.vue';
export default {
    name: 'FAQ',
    components: {
        SubHeader
    },
    data() {
        return {
            data: []
        };
    },
    mounted() {
        this.$store.dispatch('setMenuActive', '給你問');
        this.data = faq;
    }
};
</script>
